enum Paths {
    productAttributeCreate = '/products/attributes/create',
    productAttribute = '/products/attributes',
}

export default Paths;



// WEBPACK FOOTER //
// ./src/modules/ProductAttribute/paths.ts